import React from "react";
import { TYPE_PC, TYPE_SP } from "./defines";
import { Link } from "../lib/Link";

export const banner_static2 = (type) => {
  if (type == TYPE_SP) {
    return (
      <div className="banner_static2">
        <div className="banner">
          <Link to={"/trunkwithrack"}><img src="resource/img/trunkwithrack_sp.png" /></Link>
        </div>
      </div>
    );
  } else if (type === TYPE_PC) {
    return (
      <div className="banner_static2">
        <div className="banner">
          <Link to={"/trunkwithrack"}><img src="resource/img/trunkwithrack_pc.png" /></Link>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./common/banner_static2.jsx